import { Tippy } from 'static-components';
var initializeTippy = function () {
    setTimeout(function () { new Tippy(); }, 0);
};
export default initializeTippy;
